import {ApplicationModalArray} from "../../../application/components/ApplicationModalArray";
import {useAppSelector} from "../../../store/hooks";

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.leadModal);

    return isModalOpen ? <ApplicationModalArray /> : null;
}
import {ApplicationModalArray} from "../../../application/components/ApplicationModalArray";
import {useAppSelector} from "../../../store/hooks";

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.leadModal);

    return isModalOpen ? <ApplicationModalArray /> : null;
}
